import { frontendAjaxCall, JSON_CONTENT_TYPE } from "api/hooks";
import { useEffect, useState } from "react";
import store from "store";

const STORE_STATE_NAME = "widget";
const callbacks: { [key in string]?: ((next: any) => void)[] } = {};
const timeout = 200;
let throttleTimeout: null | number = null;

export const resetWidgetState = () => store.remove(STORE_STATE_NAME);
export const getWidgetState = () => store.get(STORE_STATE_NAME) ?? {};
export const setWidgetState = (state: any) => {
  store.set(STORE_STATE_NAME, state);

  // save state to backend so that it can be restored
  const search = new URLSearchParams(window.top?.location.search);
  const cartItemId = search.get("cartItemId");
  if (cartItemId && search.get("state") !== "change") {
    // when state changed schedule backend storage update
    if (!throttleTimeout) {
      throttleTimeout = setTimeout(() => {
        frontendAjaxCall("/web/cart/update/" + cartItemId, {
          body: {
            widget_state: getWidgetState(),
            cookies: window.top?.document.cookie
          },
          headers: { "Content-Type": JSON_CONTENT_TYPE },
        });
        throttleTimeout = null;
      }, timeout);
    }
  }
};

export const setWidgetStateField = (field: string, value: any) =>
  setWidgetState({
    ...getWidgetState(),
    [field]: value,
  });

export const useSharedState = <T>(
  name: string,
  initial: T
): [typeof state, typeof setState] => {
  const [state, setState] = useState<T>(initial);

  useEffect(() => {
    const array = callbacks[name] ?? [];
    const index = array.push(setState);
    callbacks[name] = array;
    array?.forEach((fn) => fn(state));
    return () => {
      array.splice(index, 1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return [state, setState];
};

export const usePersistentState = <T>(
  name: string,
  initial: T
): [typeof state, typeof setState] => {
  // const [state, setState] = useSharedState<T>(
  //   name,
  //   getWidgetState()[name] ?? initial
  // );
  const [state, setState] = useState<T>(getWidgetState()[name] ?? initial);

  return [
    state,
    (nextState: Parameters<typeof setState>[0]) => {
      setState((state) => {
        const _nextState =
          typeof nextState === "function"
            ? (nextState as (state: T) => T)(state)
            : nextState;
        setWidgetStateField(name, _nextState);
        return _nextState;
      });
    },
  ];
};
